/* import __COLOCATED_TEMPLATE__ from './intercomrade-warning.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import Component from '@glimmer/component';
import ENV from 'embercom/config/environment';

interface Signature {
  Args: {};
  Blocks: {
    default: [];
  };
}

export default class IntercomradeWarning extends Component<Signature> {
  get isNotDevelopment(): boolean {
    return ENV.environment !== 'development';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    IntercomradeWarning: typeof IntercomradeWarning;
    'intercomrade-warning': typeof IntercomradeWarning;
  }
}
